import { useState, useEffect } from 'react';

import { Box } from '@mui/material';
import MenuDrawer from './MenuDrawer';
import useUser from 'store/user/useUser';
import DisplayInformation from './DisplayInformation';
import Channel from '../../Channel';

const CoreSkillVideo = () => {
  const { student_name, student_grade, college_ci, college_name } = useUser();

  useEffect(() => {
    Channel.shutdown();
  }, []);

  const title = student_grade === 1 ? '간호사' : '(교수/조교)';

  const [menuDrawerWidth, setMenuDrawerWidth] = useState(220);
  const [isMenuName, setIsMenuName] = useState('Даалгавар илгээлтийн шалгалт');

  return (
    <Box display="flex" minWidth={1440}>
      {/* 왼쪽 메뉴 */}
      <MenuDrawer
        name={`${student_name} ${title}`}
        college_name={college_name}
        college_ci={college_ci}
        menuDrawerWidth={menuDrawerWidth}
        setMenuDrawerWidth={setMenuDrawerWidth}
        setMenuState={setIsMenuName}
        menuState={isMenuName}
      />
      {/* 오른쪽에 툴바 및 컨텐츠 */}
      <DisplayInformation
        menuDrawerWidth={menuDrawerWidth}
        menuState={isMenuName}
      />
    </Box>
  );
};

export default CoreSkillVideo;
